/**
 * Pre-compiled es messages for Pagination
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  currentPage: `Página actual`,
  goToNextPage: `Ir a la siguiente página`,
  goToPreviousPage: `Ir a la página anterior`,
  itemsPerPage: `Artículos por página`,
  itemsPerPageText: `artículos por página`,
  ofTotalPages: (args: Record<string, string | number>) =>
    `de ${args.totalPages}`,
  page: `página`,
  pagination: `paginación`,
};
